module.exports = __webpack_public_path__ + "static/img/6.28bc12f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/6.png
// module id = bvch
// module chunks = 13